import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  MdLogin,
  MdOutlineAccountBalanceWallet,
  MdOutlineSupervisorAccount,
  MdMenu,
  MdClose,
  MdHistory,
  MdPersonAdd,
  MdQrCodeScanner,
  MdCardMembership,
} from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import avatarImg from "../../images/shapes/Profile_Logo 1.png";
import LogoutModal from "../RetailerBusinessAgent/LogoutModal";

function CustomerSideBar({ user, onAgentRequest }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleNavClick = () => {
    if (mobileOpen) {
      setMobileOpen(false);
    }
  };

  // Check if user is already an advertising agent
  const isAdvertisingAgent = user?.isAdvertisingAgent || false;

  const handleBecomeAgentClick = () => {
    if (!isAdvertisingAgent && onAgentRequest) {
      onAgentRequest();
    }
  };

  return (
    <>
      <aside className={`sidebar_container1 ${mobileOpen ? "expanded" : ""}`}>
        {/* Profile Header */}
        <div className="profile1">
          <img
            src={user?.avatar || avatarImg}
            alt="Profile"
            className="profile-img1"
          />

          <div className="profile-info1">
            <h3 className="profile-name1">{user?.firstName || "Customer"}</h3>
            <p className="profile-role1">{user?.role || "Customer"}</p>
          </div>

          <button
            className="sidebar-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <MdClose /> : <MdMenu />}
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-content">
          <ul className="menu1">
            {/* Show "Refer Customer" only if user is advertising agent */}
            {isAdvertisingAgent && (
              <li>
                <NavLink
                  to="/customer/refer-customer"
                  className={({ isActive }) =>
                    isActive ? "menu-link1 active1" : "menu-link1"
                  }
                  onClick={handleNavClick}
                >
                  <MdOutlineSupervisorAccount className="icon1" />
                  Refer Customers
                </NavLink>
              </li>
            )}

            {/* Show "Referral History" only if user is advertising agent */}
            {isAdvertisingAgent && (
              <li>
                <NavLink
                  to="/customer/referral-history"
                  className={({ isActive }) =>
                    isActive ? "menu-link1 active1" : "menu-link1"
                  }
                  onClick={handleNavClick}
                >
                  <MdHistory className="icon1" />
                  Referral History
                </NavLink>
              </li>
            )}

            {/* "Become an Agent" - Show only if not already an agent and application is not pending */}
            {!isAdvertisingAgent && user?.applicationStatus !== "pending" && (
              <li>
                <button
                  className="menu-link1 become-agent-btn"
                  onClick={handleBecomeAgentClick}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#6f42c1",
                    fontWeight: "500",
                    padding: "12px 16px",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    margin: "4px 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "rgba(111, 66, 193, 0.1)";
                    e.target.style.transform = "translateX(5px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.transform = "translateX(0)";
                  }}
                >
                  <MdPersonAdd
                    className="icon1"
                    style={{
                      color: "#6f42c1",
                      marginRight: "12px",
                    }}
                  />
                  Become an Agent
                </button>
              </li>
            )}

            <li>
              <NavLink
                to="/customer/edit-profile"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <CgProfile className="icon1" />
                Edit Profile
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/customer/wallet"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdOutlineAccountBalanceWallet className="icon1" />
                Wallet (Customer)
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/customer/qr-scan"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdQrCodeScanner className="icon1" />
                Scan QR Code
              </NavLink>
            </li>

            {isAdvertisingAgent && (
              <li>
                <NavLink
                  to="/customer/wallet-network"
                  className={({ isActive }) =>
                    isActive ? "menu-link1 active1" : "menu-link1"
                  }
                  onClick={handleNavClick}
                >
                  <MdOutlineAccountBalanceWallet className="icon1" />
                  Wallet (Advertising Agent Network)
                </NavLink>
              </li>
            )}

            {/*<li>
              <NavLink
                to="/customer/card-collection"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdCardMembership className="icon1" />
                Premium Card Collection
              </NavLink>
            </li>*/}
            {!isAdvertisingAgent && (
              <li>
                <NavLink
                  to="/customer/captain-tc-card"
                  className={({ isActive }) =>
                    isActive ? "menu-link1 active1" : "menu-link1"
                  }
                  onClick={handleNavClick}
                >
                  <MdCardMembership className="icon1" />
                  Captain TC Reward Card
                </NavLink>
              </li>
            )}
            <li>
              <NavLink
                to="/customer/captain-tc-gold-card"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdCardMembership className="icon1" />
                Captain TC Gold Card
              </NavLink>
            </li>
            {isAdvertisingAgent && (
              <li>
                <NavLink
                  to="/customer/captain-tc-card"
                  className={({ isActive }) =>
                    isActive ? "menu-link1 active1" : "menu-link1"
                  }
                  onClick={handleNavClick}
                >
                  <MdCardMembership className="icon1" />
                  Captain TC Reward Card
                </NavLink>
              </li>
            )}
             {isAdvertisingAgent && (
              <li>
                <NavLink
                  to="/customer/agent-cards"
                  className={({ isActive }) =>
                    isActive ? "menu-link1 active1" : "menu-link1"
                  }
                  onClick={handleNavClick}
                >
                  <MdCardMembership className="icon1" />
                  Agents Card
                </NavLink>
              </li>
            )}
          </ul>

          <div className="bottom-menu1">
            <hr />
            <button
              className="logout-btn1"
              onClick={() => setShowLogoutModal(true)}
            >
              <MdLogin className="icon1" /> Logout
            </button>
          </div>
        </nav>
      </aside>

      {showLogoutModal && (
        <LogoutModal user={user} onClose={() => setShowLogoutModal(false)} />
      )}
    </>
  );
}

export default React.memo(CustomerSideBar);
